import login from './modules/login'

export default {
  login,
}



// WEBPACK FOOTER //
// ./src/store/login/index.js